import {
  useState, useEffect,
} from 'react'
import {
  billingService,
} from '../services/api'
import type {
  PricingResponse,
} from '../services/api'

interface UsePricingResult {
  pricing: PricingResponse | null
  loading: boolean
}

let cachedPricing: PricingResponse | null = null
let fetchPromise: Promise<PricingResponse> | null = null

function fetchPricing(): Promise<PricingResponse> {
  if (cachedPricing) return Promise.resolve(cachedPricing)
  if (!fetchPromise) {
    fetchPromise = billingService.getPricing()
      .then((data) => {
        cachedPricing = data
        return data
      })
      .catch((err) => {
        fetchPromise = null
        throw err
      })
  }
  return fetchPromise
}

export function usePricing(): UsePricingResult {
  const [pricing, setPricing] = useState<PricingResponse | null>(cachedPricing)
  const [loading, setLoading] = useState(!cachedPricing)

  useEffect(() => {
    if (cachedPricing) {
      setPricing(cachedPricing)
      setLoading(false)
      return
    }
    fetchPricing()
      .then((data) => {
        setPricing(data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  return { pricing, loading }
}
